import { OktaAuth } from '@okta/okta-auth-js';
import { useCallback, useState } from 'react';
import { logout } from '../../utils/okta';
import { useAuth } from '../../components/context/AuthContext';

/**
 * Okta hook is responsible for checking to see if a user is logged in the application.
 * If the use is not logged in, we send them to the okta login page.
 */

let authManagerHasSubscribed = false; // prevent from making multiple oktaAuth.getUser()

const useOktaHook = (oktaAuth: OktaAuth) => {
  const { updateUser: updateAuthUser, updateOktaAuth: updateAuthOktaAuth } = useAuth();
  const [hasRequestedOktaUser, setHasRequestedOktaUser] = useState<boolean>(false);

  const authManagerHandler = useCallback(
    (authState: any) => {
      if (authState.isAuthenticated) {
        updateAuthOktaAuth(oktaAuth);

        // We unsubscribe all handlers
        oktaAuth.authStateManager.unsubscribe();

        // We check to see if we've already requested for Okta user and prevent duplicate calls
        if (!hasRequestedOktaUser) {
          setHasRequestedOktaUser(true);

          // Makes a request to get the Okta User
          oktaAuth.getUser().then((oktaUser) => {
            updateAuthUser(oktaUser);
          });
        }
      } else {
        // Send the user to the okta login page
        logout(oktaAuth);
      }
    },
    [hasRequestedOktaUser, oktaAuth, updateAuthOktaAuth, updateAuthUser]
  );

  if (!authManagerHasSubscribed) {
    authManagerHasSubscribed = true;
    // We use subscribe since it's more accurate of when a user get authenticated
    oktaAuth.authStateManager.subscribe(authManagerHandler);
  }
};

export default useOktaHook;
